import { render, staticRenderFns } from "./Sedes-mod.vue?vue&type=template&id=e0999a1a"
import script from "./Sedes-mod.vue?vue&type=script&lang=js"
export * from "./Sedes-mod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports